import React, { Component, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import '../style.css';
import { Country, State, City } from 'country-state-city';
import { Col } from 'react-bootstrap';
import CardBets from './cardBets';
import CardColumns from './cardColumns';
import PopupRegister from '../../Signup/PopupRegister';
import { formatDate } from '../../utils/utils';

function MatchupCard(props) {
	const { schedules, match, user, purchasePlan, sportsName, dispatch, userActions, nbaPage } = props;

	const [showModal, setShowModal] = useState(false);

	let { sport } = useParams();
	const nflPage = sport?.toUpperCase() === 'NFL';
	const soccerPage = sport?.toUpperCase() === 'SOCCER';
	const cfbPage = sport?.toUpperCase() === 'CFB';

	// Helper: next Tuesday date string (e.g., "Tuesday, August 29, 2025")
	const getNextTuesday = () => {
		const today = new Date();
		const dayOfWeek = today.getDay(); // 0=Sun ... 2=Tue
		let daysUntilTuesday = (2 - dayOfWeek + 7) % 7;
		if (daysUntilTuesday === 0) daysUntilTuesday = 7; // push to next week if today is Tuesday
		const nextTuesday = new Date(today);
		nextTuesday.setDate(today.getDate() + daysUntilTuesday);
		return nextTuesday.toLocaleDateString('en-US', {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		});
	};

	// Helper: next Friday date string for Soccer (EPL)
	const getNextFriday = () => {
		const today = new Date();
		const dayOfWeek = today.getDay(); // 0=Sun ... 5=Fri
		const daysUntilFriday = (5 - dayOfWeek + 7) % 7;
		const nextFriday = new Date(today);
		nextFriday.setDate(today.getDate() + daysUntilFriday);
		return nextFriday.toLocaleDateString('en-US', {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		});
	};

	// Helper: NBA window message (today through 7 days from now)
	const getNBAWindowMessage = () => {
		const today = new Date();
		const nextWeek = new Date();
		nextWeek.setDate(today.getDate() + 7);
		return nextWeek.toLocaleDateString('en-US', {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		});		
	};

	// Page-wise empty state message
	//getNextTuesday() Removed due to constant changes in schedules and to avoid confusion for users. Can be added back if we want a dynamic message based on current date.
	const noGamesMessage = nflPage
		? `No games available currently, please check again later.`
		: (nbaPage
			? `No games available currently, please check again later.`
			: (soccerPage
				? `No games available currently, please check again later.`
				: 'No games available currently, please check again later.'));

	const handleLinkClick = (e) => {
		if (!user?.login && (nflPage || nbaPage || soccerPage || cfbPage)) {
			e.preventDefault();
			setShowModal(true);
		} else if (user?.login && !user?.email_verified && (nflPage || nbaPage || soccerPage || cfbPage)) {
			e.preventDefault();
			setShowModal(true);
		}
	};

	const handleSubscription = (gameArray, gameId) => {
		for (let i = 0; i <= gameArray.length; i++) {
			if (gameArray[i] === gameId) {
				return true;
			}
		}
	};

	if (!schedules) return null;
	if (!match) return null;

	if (purchasePlan.isLoaded && !purchasePlan.error) {
		window.location.reload();
	}

	let games = schedules.data && schedules.data.length !== 0 && schedules.data.schedules;

	// Build team score lookup from already-fetched healthScores data so schedule
	// cards show scores even when master_schedules cols are null (e.g. CFB).
	const teamScoreMap = {};
	if (match?.data?.teamInfo) {
		match.data.teamInfo.forEach((t) => {
			if (t.team_id != null && t.team_gaming_score != null) {
				teamScoreMap[t.team_id] = t.team_gaming_score;
			}
		});
	}

	let gameArray;
	if (user?.games) {
		gameArray = user.games.split(', ');
	}
	return (
		<React.Fragment>
			<PopupRegister
				showModal={showModal}
				setShowModal={setShowModal}
				returnUrl={window.location.pathname + window.location.search}
			/>
			{games?.length ? (
				games.map((game, i) => {
					const enrichedGame = {
						...game,
						away_team_gaming_score: game.away_team_gaming_score != null ? game.away_team_gaming_score : (teamScoreMap[game.away_team_id] ?? null),
						home_team_gaming_score: game.home_team_gaming_score != null ? game.home_team_gaming_score : (teamScoreMap[game.home_team_id] ?? null),
					};
					return (
					<Col id={game.game_id} lg={4} key={game.game_id || i} className='cardCol'>
						<div className='cardColDiv'>
							{(user?.login || (!user?.login && i == 0)) ? (
								<Col lg={12} className='cardDetailsCol'>
									<p className='cardDetails text-center' style={{ fontSize: '20px' }}>
										Team Health Scores
									</p>
								</Col>
							) : null}

							{/* Game Spread Section */}

							<div className='cardSpreadDiv'>{(user?.login || (!user?.login && i == 0)) ? <CardBets game={enrichedGame} /> : <div style={{ padding: '27.5px 0' }} />}</div>

							{/* Game Home/Away Team Columns */}

							<CardColumns handleSubscription={gameArray && handleSubscription(gameArray, game.game_id)} game={enrichedGame} gameArray={gameArray} userAllowed={(user?.login || (!user?.login && i == 0))} sportsID={user?.sportsID} />

							<Col lg={12} className='cardViewGameCol'>
								<Link
									className='cardViewGameButton hover-delay'
									title='View Game'
									to={{
										pathname: `/${sportsName || 'nfl' || 'nfl'}/matchup/${game.game_id}`,
										match: match
									}}
									onClick={handleLinkClick}
								>
									{user?.login ? 'VIEW MATCHUP' : 'LOG IN OR JOIN FOR FREE'}
									{/* {(user?.login || (!user?.login && i == 0)) ? 'VIEW MATCHUP' : 'LOG IN OR JOIN FOR FREE'} */}
								</Link>
							</Col>

							{/* Game Spread */}

							<Col lg={12} className='cardDetailsCol'>
								<p className='cardDetails cardDate text-center' style={{ fontSize: '14px' }}>
									{(game.date_time && formatDate(false, game.date_time?.date)) || (game.day && formatDate(false, game.day)) ? (game.date_time ? formatDate(false, game.date_time?.date) : formatDate(false, game.day)) : 'TBD'}
								</p>
							</Col>
						</div>
					</Col>
					);
				})
			) : (
				<h2 style={{ textAlign: 'center', margin: '30px auto' }}>{noGamesMessage}</h2>
			)}
		</React.Fragment>
	);
}

const mapStateToProps = (state) => ({
	isLoading: state.isLoading,
	isLoaded: state.isLoaded,
	schedules: state.schedules,
	match: state.match,
	user: state.user,
	purchasePlan: state.purchasePlan,
	sources: state.sources
});

export default connect(mapStateToProps)(MatchupCard);
